import { useQuery } from "@tanstack/react-query";
import { getPlayers } from "../../../api";

/**
 * Gets all the players for a tenant. Note that this includes
 * all players, not just those for the current game.
 */
export function usePlayersQuery() {
  return useQuery({
    queryKey: ["players"],
    queryFn: async () => {
      return await getPlayers();
    },
  });
}
